export default class inputType {
    constructor() {

        return {
            restrict: 'E',
            scope: {
                value: '=ngModel',
                rule: '=',
                groups: '=',
                languages: '=',
                suppressionOptions: '='
            },
            controller: ['$scope', '$element', '$attrs', '$q', '$compile', '$templateCache', '$http', '$timeout', (scope, element, attr, $q, $compile, $templateCache, $http, $timeout) => {

                let unWatchGroup;
                let unWatchRule;
                let unWatchField;

                var templates = {
                    'text': '',
                    'single': '<input type="text" ng-model="value">',
                    'multiple': '',
                    'json': '<input type="text" ng-model="value">',
                    'datetime': '<input type="text" ng-model="value">',
                    'date': '<input type="text" ng-model="value">',
                    'time': '<input type="text" ng-model="value">'
                };

                var getTemplate = (inputType) => {
                    var templateMap = {
                        text: require('../../../../views/segment/input-types/text.html'),
                        multiple: require('../../../../views/segment/input-types/multiple.html'),
                        datetime: require('../../../../views/segment/input-types/datetime.html'),
                        date: require('../../../../views/segment/input-types/date.html'),
                        integer: require('../../../../views/segment/input-types/integer.html'),
                        empty: require('../../../../views/segment/input-types/empty.html'),
                        language: require('../../../../views/segment/input-types/lang.html'),
                        suppression: require('../../../../views/segment/input-types/suppression.html'),
                        email: require('../../../../views/segment/input-types/email.html'),
                        phone_number: require('../../../../views/segment/input-types/phone_number.html')
                    };

                    return templateMap[inputType]
                };

                var getField = (fieldId, groups) => {
                    var index = _.findIndex(groups, (group) => {
                        return group.fieldId == fieldId
                    })

                    if (index > -1) {
                        return groups[index];
                    }
                };

                if (angular.isArray(scope.rule.value)) {
                    scope.loadedOptions = scope.rule.value;
                }

                 unWatchField = scope.$watch('rule.field', (newVal, oldVal) => {
                    if (newVal == oldVal) {
                        return
                    }
                    scope.value = null;
                });

                // Get group data async, because it will load after the field
                var hasGroups = () => {
                    var deferred = $q.defer();

                    if (scope.groups && scope.groups.length) {
                        deferred.resolve()
                    }

                    unWatchGroup = scope.$watch('groups', (newVal, oldVal) => {
                        if (newVal != oldVal) {
                            deferred.resolve()
                        }
                    });
                    return deferred.promise
                };

                var appendTemplate = (field, operator, oldOperator) => {
                    var fieldType;

                    scope.customField = getField(field, scope.groups);

                    if (field === 'language') {
                        fieldType = 'language'
                    } else if (field === 'email') {
                        fieldType = 'email'
                    } else if (! scope.customField) {
                        fieldType = 'text'
                    } else {
                        fieldType = scope.customField.fieldType
                    }

                    scope.loadedOptions = scope.rule.value;
                    // Force a specific type
                    switch (operator) {
                        case 'max_days':
                        case 'min_days':
                        case 'is_days': {
                            fieldType = 'integer';
                            break
                        }
                        case 'is_not_empty':
                        case 'is_empty':
                        case 'yearly': {
                            fieldType = 'empty';
                            break
                        }
                    }

                    if (operator !== oldOperator) {
                        scope.value = fieldType === 'empty' ? '' : null;
                    }

                    var fieldTemplate = getTemplate(fieldType);
                    var templateObj = $compile(angular.element(fieldTemplate))(scope);
                    $timeout(() => {
                        scope.$apply(() => {
                            element.html(templateObj)
                        })
                    })
                };

                hasGroups().then(() => {
                    unWatchRule = scope.$watch('rule', (newVal, oldVal) => {
                        // Value changed, ignore
                        if (newVal.value === oldVal.value ||
                            newVal.operator !== oldVal.operator ||
                            newVal.field !== oldVal.field
                        )
                        {
                            appendTemplate(newVal.field, newVal.operator, oldVal.operator)
                        }

                    }, true)
                });

                scope.$on('$destroy', () => {
                    if (unWatchField) unWatchField();
                    if (unWatchGroup) unWatchGroup();
                    if (unWatchRule) unWatchRule();
                });
            }]
        }
    }
}
